<template>
  <div class="home" ref="HomePage">
    <div class="header">
      <img alt="Vue logo" src="../assets/logo.png" />
      <ul>
        <li @click="scrollToItem('advantage')">优势</li>
        <li @click="scrollToItem('chat')">产品</li>
        <li @click="scrollToItem('partners')">合作伙伴</li>
      </ul>
    </div>
    <div class="banner">
      <div class="bigTitle">企业服务器，满足未来业务需求</div>
      <div class="smallDesc">能够满足当今挑战的服务器基础架构还远远不够。</div>
      <div class="smallDesc">
        StarFronts 企业服务器旨在应对今天以及未来全球大部分数据密集型工作负载。
      </div>
      <div class="chatBtn" onclick="showChatBOx()">立即咨询</div>
      <div class="chatBtn wap" @click="toWapChat()">立即咨询</div>
    </div>
    <div class="advantage" name="advantage">
      <div class="title">我们的优势</div>
      <ul>
        <li>
          <img src="../assets/data.png" alt="" />
          <span>企业数据保存在<br />企业内部的服务器上</span>
        </li>
        <li>
          <img src="../assets/chat.png" alt="" />
          <span>及时通讯提高<br />企业的内部沟通效率</span>
        </li>
        <li>
          <img src="../assets/search.png" alt="" />
          <span>企业内部高效搜索<br />服务器提高历史数据的有效查询</span>
        </li>
      </ul>
    </div>
    <div class="chat" id="itemTwo">
      <div class="title">及时通讯服务器</div>
      <div class="desc">
        多样化消息类型，全面满足通讯需求<br />
        完整的配套功能，悉数覆盖通信场景<br />
        接入IM SDK，即刻拥有私聊、群聊、聊天室等通讯能力
      </div>
    </div>
    <div class="client">
      <div class="title">企业客户端机器</div>
      <div class="desc">
        StarFronts 除了企业定制服务器，<br />
        还包括定制企业客户端机器，根据企业定制桌面电脑。
      </div>
    </div>
    <div class="data">
      <div class="title">企业大数据搜索服务器</div>
      <div class="desc">
        聚焦数据，提供数据挖掘、安全、容灾、运维、分析等产品<br />
        深入行业场景、剖析行业痛点，全面满足行业用户合规及业务发展需求
      </div>
    </div>
    <div class="partners" id="itemThree">
      <div class="title">合作伙伴</div>
      <ul class="case">
        <li v-for="key in 10" :key="key">
          <img :src="require('../assets/client (' + key + ').jpg')" alt="" />
        </li>
      </ul>
    </div>
    <div class="footer">
      <div>
        StarFronts(TM) Copyright© 2005 - 2019 StarFronts Corporation. All rights
        reserved.
      </div>
      <div style="margin-top: 10px;">
        <a href="https://beian.miit.gov.cn" class="open" target="_blank">ICP备案/许可证号：蜀 ICP 备 15003211号-2</a>
      </div>
    </div>
    <img
      class="wapChatICON"
      @click="toWapChat()"
      ref="wapchatIcon"
      src="../assets/services.png"
      alt=""
    />
  </div>
</template>

<script>
// @ is an alias to /src
import $ from "jquery";
export default {
  name: "home",
  methods: {
    scrollToItem(itemId) {
      let index = 0;
      switch (itemId) {
        case "advantage":
          index = 2;
          break;
        case "chat":
          index = 3;
          break;
        case "partners":
          index = 6;
          break;
      }
      let toTop = this.$el.children[index].offsetTop;
      $("html,body").animate({ scrollTop: toTop }, 1000);
    },
    toWapChat() {
      window.location.href =
        "https://tchat.melinked.com?key=27E2072FD9D9C5F66436AA7AFEB10E3F&lang=1&title=StarFronts";
    },
  },
};
</script>
<style lang="less">
@import "../assets/media.less";
body {
  margin: 0;
  padding: 0;
  #app {
    font-family: "Microsoft YaHei";
  }
}
.wapChatICON {
  position: fixed;
  bottom: 5rem;
  right: 1rem;
  z-index: 1000;
  cursor: pointer;
  display: none;
  // box-shadow: 0 0 1px 2px rgba(144,144,144,.4);
  border-radius: 5rem;
  width: 6rem;
}
.home {
  display: flex;
  flex-flow: column;
  .header {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    height: 62px;
    padding: 0 8rem;
    ul {
      width: 30rem;
      display: flex;
      flex-flow: row;
      justify-content: space-around;
      font-size: 20px;
      color: #333333;
      font-family: "Microsoft YaHei";
      // font-weight: bold;
      li {
        list-style: none;
        cursor: pointer;
      }
    }
  }
  .banner {
    height: 480px;
    background: url("../assets/banner.jpg");
    background-size: cover;
    text-align: center;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 600;
    font-stretch: normal;
    // line-height: 80px;
    letter-spacing: 1px;
    .bigTitle {
      line-height: 80px;
      font-size: 72px;
      margin: 0 0 1rem;
    }
    .smallDesc {
      font-size: 20px;
      line-height: 28px;
    }
    .chatBtn {
      width: 298px;
      height: 52px;
      background-color: #4caf50;
      margin-top: 2rem;
      box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
      border-radius: 26px;
      line-height: 52px;
      cursor: pointer;
      &.wap {
        display: none;
      }
    }
  }
  .advantage {
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding: 3rem 0;
    .title {
      font-size: 44px;
      color: #000000;
      margin-bottom: 0.98rem;
    }
    ul {
      padding: 0 8rem;
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      li {
        list-style: none;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        span {
          font-size: 18px;
          margin-top: 0.9rem;
          // max-width: 200px;
          text-align: center;
        }
      }
    }
  }
  .chat,
  .client,
  .data,
  .partners {
    height: 440px;
    background: url("../assets/chatBg.jpg");
    background-size: cover;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    .title {
      font-size: 44px;
      margin-bottom: 0.95rem;
    }
    .desc {
      font-size: 20px;
      line-height: 28px;
    }
  }
  .client {
    background: url("../assets/clientBg.jpg");
    color: #333333;
  }
  .data {
    background: url("../assets/dataBg.jpg");
  }
  .partners {
    background: none;
    color: #333333;
    height: auto;
    padding: 2rem 0;
    .case {
      display: flex;
      padding: 0 8rem;
      flex-wrap: wrap;
      justify-content: space-around;
      li {
        margin: 0 0.5rem;
        list-style: none;
      }
    }
  }
  .footer {
    margin-top: 2rem;
    padding: 3.5rem 8rem;
    border-top: 1px solid #f5f5f5;
    .open {
      color: #8590a6;
      text-decoration: none;
      &:hover{
        color: #175199;
      }
    }
  }
}
</style>
